$(document).ready(function () {

    $(".metafield--color-swatch .meta--ttl.persent_sign").attr("data-had-percent", "true");
    
    $(".main--color-margin-bundle .metafield--color-swatch").each(function () {
        let title = $(this).find(".meta--ttl").first().attr("title");
        let getFirst = $(this).find(".meta--ttl").first();

        $(getFirst).addClass("active_title");

        if ($(getFirst).attr("data-had-percent") == "true") {
            $(getFirst).removeClass("persent_sign");
        }

        if (title) {
            $(this).closest(".main--color-margin-bundle").find(".span--color-name").text(title);
        }
    });

    $(".metafield--color-swatch .meta--ttl").click(function () {

        var $container = $(this).closest(".metafield--color-swatch");
        var $prevActive = $container.find(".meta--ttl.active_title");

        $prevActive.removeClass("active_title");
        if ($prevActive.attr("data-had-percent") == "true") {
            $prevActive.addClass("persent_sign");
        }

        $(this).addClass("active_title");

        if ($(this).attr("data-had-percent") == "true") {
            $(this).removeClass("persent_sign");
        }

        var title = $(this).attr("title");

        $(this).closest(".main--color-margin-bundle").find(".span--color-name").text(title);
    });

    var firstId;
    var secondId;

    $(document).on("click", ".single_variant_data_wrapper_0 .single_variant_data", function () {
        // alert("clicked 0");
        var getvariantId = $(this).attr("vari_id");
        firstId = getvariantId; // Directly assign the variant ID
    });

    $(document).on("click", ".single_variant_data_wrapper_1 .single_variant_data", function () {
        // alert("clicked 1");
        var getvariantId = $(this).attr("vari_id");
        secondId = getvariantId; // Directly assign the variant ID
        // $(".bundle_product_add_to_cart_hide .get_current_prd_id").val(secondId);
        $(".bundle_product_add_to_cart_hide .get_current_prd_id").val("");
        $(".bundle_product_add_to_cart_hide buy-buttons button").removeAttr("disabled");
    });

    $(document).on("click", "#bundle_add_to_cart", function () {
        // ✅ Capture bundle title from hidden input
        window.currentBundleTitle = $(".bundle_product_add_to_cart_hide input[name='properties[_bundle_title]']").val();

        var bundleTimestamp = Date.now().toString();

        // the cart lists the newest line first, so add the bottom first and the top last: the top then shows first (BR 10.23)
        var items = [
            {
                id: secondId,
                quantity: 1,
                properties: {
                    _bundle_key: bundleTimestamp,
                    _bundle_title: window.currentBundleTitle,
                },
            },
            {
                id: firstId,
                quantity: 1,
                properties: {
                    _bundle_key: bundleTimestamp,
                    _bundle_title: window.currentBundleTitle,
                },
            },
        ];

        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: { items: items },
            dataType: "json",
            success: function (data) {
                console.log("Bundle added:", data);

                // ✅ Drawer open
                const drawerEl = document.querySelector("cart-drawer, #CartDrawer, dialog#CartDrawer");
                if (drawerEl) {
                    if (typeof drawerEl.showModal === "function") {
                        drawerEl.showModal();
                    } else if (typeof drawerEl.show === "function") {
                        drawerEl.show();
                    }
                }

                // ✅ Trigger cart refresh
                document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cart: data } }));
            },
        });
    });

    // Color options js start
    $(document).on("click", ".metafield--color-swatch .a-metalink .meta--ttl", function () {
        var nextElement = $(this).next(); // Finds the next sibling element
        var currentVariants = $(this).closest(".main-bundle-product").find(".current_product_variants");



        if (nextElement.length) {

            var clonedElement = nextElement.clone();

            var sizeChartBtn = currentVariants.find(".size--chart-color").parent().clone();

            // sab remove karo
            $(currentVariants).children().remove();

            // pehle cloned variants daalo
            currentVariants.append(clonedElement);

  
            var clrBlock = currentVariants.find("fieldset[name='size'] legend.size_variant.clr--name-swatch");

            clrBlock.empty();

            clrBlock.append(
                '<div class="updated_content">' +
                '</div>'
            )

            var wrapper = clrBlock.find(".size_variant-head");
            if (wrapper.length) {
                wrapper.empty();
            } else {
                wrapper = $('<div class="js_change_type"></div>');
                clrBlock.append(wrapper); 
            }

            wrapper.append(sizeChartBtn);
            clrBlock.css("width", "100%");

            currentVariants.find(".color_variant_options_bundle").css({
                "padding-bottom": "25px",
                "margin-bottom": "40px",
                "border-bottom": "1px solid gray"
            });

            setTimeout(function () {
                checkfirstoption(currentVariants);
            }, 100);
        } else {
            console.log("No next element found");
        }

        var groupDetails = $(this).closest(".main-bundle-product").find(".product_details");

        var new_popup_details = $(this).closest(".main-bundle-product").find(".product_details .product_view_under_popup");

        var color_parent = $(this).closest(".a-metalink");
        var titleproduct = $(color_parent).attr("prdTilte");
        var image_product = $(color_parent).attr("prdHandleImage");
        var Urlproduct = $(color_parent).attr("produrl");

        // set image src
        groupDetails.find(".picture_change").attr("src", image_product);

        // set title text
        groupDetails.find(".prd_title a").text(titleproduct);
        groupDetails.find(".prd_title a").attr("href", Urlproduct);
        groupDetails.find(".content_info .jdgm-rev-widg__title").text(titleproduct);
        groupDetails.find(".content_info .popup_heading").text(titleproduct);
         
        // set anchor href
        groupDetails.attr("href", Urlproduct);
        new_popup_details.attr("href", Urlproduct);

        updateBundlePrice();
    });

    checkfirstoption($(".single_variant_data_warpper__1"));
    checkfirstoption($(".single_variant_data_warpper__2"));
    
    updateBundlePrice();
});

function updateBundlePrice() {
    let totalPrice = 0;
    let currencySymbol = "";

    $(".meta--ttl.active_title").each(function () {
        let price = $(this).attr("data-price-custom");

        if (price) {
            if (!currencySymbol) {
                currencySymbol = price.charAt(0);
            }
            totalPrice += parseFloat(price.substring(1)) || 0;
        }
    });

    $(".product-info__block-item .hide--ttl sale-price").text(
        currencySymbol + totalPrice.toFixed(2)
    );

    $(".mobile_head_price .ctm_product_head_price sale-price").text(
        currencySymbol + totalPrice.toFixed(2)
    );
}


function setVarientsForAddToBag(pid, jsonData, mainEl) {
    var op1Sel = jsonData.find((x) => x.isActive);
    var op2Sel = jsonData.find((x) => x.isActive2);

    if (op2Sel && op2Sel.option2) {
        console.log(op1Sel.option1, op2Sel.option2);
        var el = $(mainEl).find(
            ".single_variant_data" +
                "[prd_id='" +
                pid +
                "'][option_1='" +
                op1Sel.option1 +
                "'][option_2='" +
                op2Sel.option2 +
                "']"
        );
        $(el).addClass("active").trigger("click");
    } else {
        console.log(op1Sel.option1, "NA");
        var el = $(mainEl).find(".single_variant_data" + "[prd_id='" + pid + "'][option_1='" + op1Sel.option1 + "']");
        $(el).addClass("active").trigger("click");
    }
}

function checkfirstoption(curr) {
    var varientList = [];
    var hasOp2 = false;
    var op1List = [];
    var pid = 0;

    $(curr)
        .find(".single_variant_data")
        .each(function (i, el) {
            //debugger;

            var option1 = $(el).attr("option_1");
            var option2 = $(el).attr("option_2");
            var qty = $(el).attr("variantqty");
            var dataavailale = $(el).attr("variantavailable");

            pid = $(el).attr("prd_id");
            if (option2) {
                hasOp2 = true;
            }

            if (op1List.indexOf(option1) == -1) {
                op1List.push(option1);
            }

            //debugger;

            var isActive = $(curr)
                .find(".label__font_" + pid + "[option_1='" + option1 + "']")
                .hasClass("active");
            var isActive2 = false;
            if (hasOp2) {
                isActive2 = $(curr)
                    .find(".label__font_" + pid + "[option_2='" + option2 + "']")
                    .hasClass("active");
            }
            varientList.push({
                id: pid,
                option1: option1,
                option2: option2,
                qty: qty,
                avl : dataavailale,
                isActive: isActive,
                isActive2: isActive2,
            });
        });

    //debugger;
    //------------------set first selected---------
    if (varientList.filter((x) => x.isActive).length == 0) {
        var salVari = varientList.filter((x) => x.avl === 'true'); // BR 10.23: avl is the string "true"/"false"
        if (salVari.length > 0) {
            salVari[0].isActive = true;
            $(curr)
                .find(".label__font_" + pid + "[option_1='" + salVari[0].option1 + "']")
                .addClass("active");
        }
    }

    if (varientList.length > 0) {
        console.log(varientList);
        //------------------set option 1 enable disable---------
        // if (op1List.length > 0) {
        //     op1List.forEach(function (item) {
        //         console.log(item);
        //         // console.log(x);
        //         if (varientList.filter((x) => x.option1 == item && x.avl).length == 0) {
        //             $(curr)
        //                 .find(".label__font_" + pid + "[option_1='" + item + "']")
        //                 .addClass("disabled");
        //         } else {
        //             $(curr)
        //                 .find(".label__font_" + pid + "[option_1='" + item + "']")
        //                 .removeClass("disabled");
        //         }
        //     });
        // }
        
     if (op1List.length > 0) {
    op1List.forEach(function (item) {

        const isAvailable = varientList.some(function (x) {
            return x.option1 === item && x.avl === 'true';
        });

        $(curr)
            .find(".label__font_" + pid + "[option_1='" + item + "']")
            .toggleClass("disabled", !isAvailable);
    });
}

        if (hasOp2) {
            //debugger;
            //------------------set first selected---------
            if (varientList.filter((x) => x.isActive2).length == 0) {
                var salVari = varientList.filter((x) => x.avl === 'true'); // BR 10.23: avl is the string "true"/"false"
                if (salVari.length > 0) {
                    salVari[0].isActive2 = true;
                    $(curr)
                        .find(".label__font_" + pid + "[option_2='" + salVari[0].option2 + "']")
                        .addClass("active");
                }
            }

            //------------------set option 2 enable disable---------
            var sel_option1 = varientList.filter((x) => x.isActive)[0].option1; //for current selection
            var sal_data = varientList.filter((x) => x.option1 == sel_option1);
            console.log(sal_data);

            // Check if selected option2 is still valid
            var activeOp2 = sal_data.find((x) => x.isActive2);
            // BR 10.23: Shopify's availability, not qty == "0" (oversold stock is negative - Black M/Regular at -2 showed
            // in stock and then failed to add; "continue selling" variants can sit at 0 and still sell)
            if (!activeOp2 || activeOp2.avl !== 'true') {
                // Remove previous active class
                $(curr)
                    .find(".label__font_" + pid + "[option_2].active")
                    .removeClass("active");

                // Select first available option2
                var firstAvailable = sal_data.find((x) => x.avl === 'true');
                if (firstAvailable) {
                    firstAvailable.isActive2 = true;
                    $(curr)
                        .find(".label__font_" + pid + "[option_2='" + firstAvailable.option2 + "']")
                        .addClass("active");
                }
            }

            sal_data.forEach(function (el) {
                if (el.avl !== 'true') {
                    $(curr)
                        .find(".label__font_" + el.id + "[option_2='" + el.option2 + "']")
                        .addClass("disabled");
                } else {
                    $(curr)
                        .find(".label__font_" + el.id + "[option_2='" + el.option2 + "']")
                        .removeClass("disabled");
                }
            });
        }
    }

    setVarientsForAddToBag(pid, varientList, curr);
}

function labelClick(el) {
    $(el).siblings(".label__font").removeClass("active");
    $(el).addClass("active");
    checkfirstoption($(el).parent().parent());
}


let originalZIndex = '';
// let originalOverflow = '';

$(".product_details .anchor_details").on('click', function(e) {
    e.preventDefault();

    const header = $(".shopify-section-group-header-group");

    // Original values save karo
    // originalZIndex = header.css('z-index');
    // originalOverflow = $('body').css('overflow');

    // New values set karo
    header.css('z-index', '2');
    // $('body').css('overflow', 'hidden');
    $("body").addClass("hide-overflow");

    $(this).siblings(".custom-model-main").addClass('model-open');
});

$(".close-btn-ctm, .bg-overlay").on('click', function() {

    $(".custom-model-main").removeClass('model-open');
    $("body").removeClass("hide-overflow");

    // Original values restore karo
    $(".shopify-section-group-header-group").css('z-index', '4');
    // $('body').css('overflow', originalOverflow);
});